import { render, staticRenderFns } from "./TracksStudentsWidget.vue?vue&type=template&id=7ea54e54&scoped=true"
import script from "./TracksStudentsWidget.vue?vue&type=script&lang=js"
export * from "./TracksStudentsWidget.vue?vue&type=script&lang=js"
import style0 from "./TracksStudentsWidget.vue?vue&type=style&index=0&id=7ea54e54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea54e54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea54e54')) {
      api.createRecord('7ea54e54', component.options)
    } else {
      api.reload('7ea54e54', component.options)
    }
    module.hot.accept("./TracksStudentsWidget.vue?vue&type=template&id=7ea54e54&scoped=true", function () {
      api.rerender('7ea54e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/TracksStudentsWidget.vue"
export default component.exports